import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer ">
      <div className="footer_container w-[96%]">
        <div className="flex w-full gap-4 flex-wrap mb-5">
          <div className="footer_logo flex flex-col gap-3">
            <div className="sm:text-[36px] text-[25px] font-medium uppercase text-[#ffffff] sm:leading-10 leading-7">
              Kicks
            </div>
            <div className="md:text-sm text-xs text[var(--text-gray-color)] text-gray-400">
              Your one-stop destination for premium sneakers. Discover the
              latest drops, classic styles, and everyday comfort — all at
              unbeatable quality.
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-5">
          <div className="flex flex-row justify-between items-center text-xs text-gray-400">
            <p className="mb-2 md:mb-0">
              Developed by Firdosh © {new Date().getFullYear()}
            </p>
            <div className="flex md:space-x-4 space-x-2">
              <a href="/" className="hover:text-gray-200 transition-colors">
                Home
              </a>
              <span className="text-gray-600">|</span>
              <a
                href="products"
                className="hover:text-gray-200 transition-colors"
              >
                Products
              </a>
              <span className="text-gray-600">|</span>
              <a
                href="about-us"
                className="hover:text-gray-200 transition-colors"
              >
                About
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
